module.exports = __webpack_public_path__ + "img/Mascot_vie.ae6f878a.png";